(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientGroupDetailController', PatientGroupDetailController);

    PatientGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PatientGroup', 'Clinic', 'Patient'];

    function PatientGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, PatientGroup, Clinic, Patient) {
        var vm = this;

        vm.patientGroup = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:patientGroupUpdate', function(event, result) {
            vm.patientGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
